// extracted by mini-css-extract-plugin
export default {"message_reply":"styles_message_reply__HkbtE","message_reply_icon":"styles_message_reply_icon__s3-8U"};